import type { Quote } from '../types';
import { formatDate } from '@/lib/utils';

/**
 * Export orders to CSV with injection protection
 */
export function exportOrdersToCsv(
  orders: Quote[],
  filename = 'orders',
): void {
  // Sanitize cell value to prevent CSV injection
  const sanitize = (value: string | number | null | undefined): string => {
    if (value == null) return '';
    const str = String(value);
    // Prevent formula injection
    if (/^[=+\-@\t\r]/.test(str)) {
      return `'${str}`;
    }
    // Escape quotes
    if (str.includes('"') || str.includes(',') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const headers = [
    'Quote #',
    'Status',
    'Account',
    'Project',
    'Account Manager',
    'Total',
    'Currency',
    'Created Date',
    'Accepted Date',
    'PO Number',
    'HubSpot',
    'Google Drive',
  ];

  const rows = orders.map((order) => [
    sanitize(order.quoteNumber),
    sanitize(order.status),
    sanitize(order.accountName),
    sanitize(order.projectName),
    sanitize(order.salesManagerName),
    sanitize(parseFloat(order.total) || 0),
    sanitize(order.currency),
    sanitize(order.createdDate ? formatDate(order.createdDate) : ''),
    sanitize(order.acceptedDate ? formatDate(order.acceptedDate) : ''),
    sanitize(order.poNumber),
    sanitize(order.hubspotLink),
    sanitize(order.gdriveLink),
  ]);

  const csv = [
    headers.join(','),
    ...rows.map((row) => row.join(',')),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
